import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'subtract',
  standalone: true,
})
export class SubtractPipe implements PipeTransform {
  transform(value: any, subtrahend: any): number {
    const a = this.coerceNumber(value);
    const b = this.coerceNumber(subtrahend);
    return a - b;
  }

  private coerceNumber(input: any): number {
    if (input === null || input === undefined || input === '') return 0;
    const n = Number(input);
    return isNaN(n) ? 0 : n;
  }
}
